import { render, staticRenderFns } from "./wisataDetile.vue?vue&type=template&id=e25d21d0&"
import script from "./wisataDetile.vue?vue&type=script&lang=js&"
export * from "./wisataDetile.vue?vue&type=script&lang=js&"
import style0 from "./wisataDetile.vue?vue&type=style&index=0&id=e25d21d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports